import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { UserLocationContext } from '@honda-canada/user-location';
import { Button } from '@honda-canada/design-system-react';
import themeStyles from './UserLocationButton.style';
import formatGeoObject from '../../utils/formatGeoObject';
import { pushGtmDealerSearchType, GEO_DETECTION } from '../../utils/gtmTags';
import { DealersListContext } from '../DealersListContext';
import { USER_PLACE_LOCALSTORAGE_KEY } from '../../utils/constants';

const SecondaryButton = themeStyles.apply(Button, 'SecondaryButton');

const UserLocationButton = ({ setSelectedPlace, setIsOpen, setInputValue, setSelectedDealer, children }) => {
  // browser GeoLocation detection
  const { isFetchingUserLocation, detectUserLocationFromBrowser, resetError } = useContext(UserLocationContext) || {};
  const { productLinesSelection } = useContext(DealersListContext) || {};

  const onGeoLocationSuccess = geoObject => {
    localStorage.setItem(USER_PLACE_LOCALSTORAGE_KEY, JSON.stringify(geoObject));
    const parsedAddress = formatGeoObject(geoObject);
    setInputValue(parsedAddress);
    setSelectedPlace({ ...geoObject });
    setSelectedDealer(null);
    setIsOpen(false);
    const userGeoLocationData = { ...geoObject };
    pushGtmDealerSearchType(GEO_DETECTION, userGeoLocationData, productLinesSelection);
  };

  const persistLocationToCookies = false;

  const handleClick = async () => {
    resetError();
    detectUserLocationFromBrowser(onGeoLocationSuccess, persistLocationToCookies);
  };

  return (
    <SecondaryButton
      styling="secondary"
      disabled={isFetchingUserLocation}
      onClick={handleClick}
      data-testid="cy-user-location-btn"
    >
      {children}
    </SecondaryButton>
  );
};

export default UserLocationButton;

UserLocationButton.propTypes = {
  children: PropTypes.node,
  setSelectedPlace: PropTypes.func,
  setIsOpen: PropTypes.func,
  setInputValue: PropTypes.func,
  setSelectedDealer: PropTypes.func,
};
